// Sticky add-to-cart — reveals the floating bottom bar once the main buy region
// scrolls out of view, hides it again when scrolled back. Progressive
// enhancement: the bar starts [hidden]; with JS off it never shows. The qty
// stepper mirrors the real product-form quantity input.
(() => {
  const bar = document.querySelector('[data-sticky-atc]');
  const region = document.querySelector('[data-buy-region]');
  if (!bar || !region || !('IntersectionObserver' in window)) return;

  bar.hidden = false; // enable it (CSS keeps it off-screen until .is-visible)

  const io = new IntersectionObserver(
    ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting),
    { threshold: 0 }
  );
  io.observe(region);

  // Qty stepper — mirrors the real quantity input (quantity block) so the form
  // posts what the bar shows. No quantity block on the page = no stepper.
  const out = bar.querySelector('[data-sticky-qty-value]');
  if (!out) return;
  const formId = bar.querySelector('[form]').getAttribute('form');
  const input = document.querySelector(`input[name="quantity"][form="${formId}"]`);
  if (!input) {
    out.closest('[data-sticky-qty]').remove();
    return;
  }
  const sync = () => { out.textContent = input.value || '1'; };
  bar.querySelectorAll('[data-sticky-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const min = Number(input.min) || 1;
      const max = Number(input.max) || Infinity;
      const step = Number(input.step) || 1;
      input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + step * Number(btn.dataset.stickyStep)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    });
  });
  input.addEventListener('change', sync);
  sync();
})();
